import React, { FC, useEffect, memo } from 'react';
import { GIFTCARD_STYLES } from '../utils';

import styles from './styles.module.scss';

type CloverGiftCardPaymentInputProps = {
  fieldName: Clover.InputFieldType;
  onValidationBlur: (returnedState: Clover.ReturnedAchState) => void;
  onValidationChange: (returnedState: Clover.ReturnedAchState) => void;
  className?: string;
  cloverElementsInstance: Clover.ElementRoot;
}

export const CloverGiftCardPaymentInputImpl: FC<CloverGiftCardPaymentInputProps> = ({ cloverElementsInstance, fieldName, children, onValidationChange, onValidationBlur, ...props }) => {
  const id = fieldName.toLocaleLowerCase();

  const handleOnChange = (returnedState: Clover.ReturnedAchState) => onValidationChange(returnedState);

  const handleOnBlur = (returnedState: Clover.ReturnedAchState) => onValidationBlur(returnedState);

  useEffect(() => {
    const element = cloverElementsInstance.create(fieldName, GIFTCARD_STYLES);
    element.mount(`#${id}`);

    element.addEventListener('change', handleOnChange);
    element.addEventListener('blur', handleOnBlur);

    return () => {
      element.removeEventListener('change');
      element.removeEventListener('blur');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id={id} className={styles.giftCardFrameContainer} {...props} />
  );
};

export const CloverGiftCardPaymentInput = memo(CloverGiftCardPaymentInputImpl);
